module.exports = __webpack_public_path__ + "static/1266704391.fed0e73a.jpg";